export const PROCESS = "PROCESS";
export const APPROVED = "APPROVED";
export const REJECTED = "REJECTED";
export const PENDING = "PENDING";
export const SUCCESS = "SUCCESS";
export const FAILURE = "FAILURE";
export const COMPLETED = "COMPLETED";
export const CREDIT = "CREDIT";
export const CLOSED = "CLOSED";
export const REFUND = "REFUND";
export const FAIL = "FAIL";
export const DEBIT = "DEBIT";
export const ALL = "ALL";
export const INPROGRESS = "INPROGRESS";
export const NEW = "NEW";
export const CANCEL = "CANCEL";
export const RESCHEDULED = "RESCHEDULED";
export const OUTFORDELIVERY = "OUT FOR DELIVERY";
export const DELIVERED = "DELIVERED";
export const CANCELED = "CANCELED";
export const PARTIALLY_PAID = "PARTIALLY PAID";
export const NOT_AVAILABLE = "NOT AVAILABLE";
export const CONFIRMED = "CONFIRMED";
export const NONE = "NONE";
export const CASHONDELIVERY = "CASH ON DELIVERY";
export const PC = "PC";
export const KG = "KG";
export const SQFT = "Sq. Ft.";
export const OTHER = "Other";
export const Customer = "2";